import Joi from 'joi';

export const CabinetMinisterSchema = Joi.object({
  cabinetId: Joi.number().required(),
  ministerId: Joi.number().required(),
  ministerPositionId: Joi.number().required(),
  regions: Joi.array().items(Joi.string()).min(1).required()
});
